export { powershellRestmethod } from './restmethod.js';
